import React from "react";
import FieldContainer from "../FieldContainer";
import Input, { InputProps } from "../ui/Input";

interface Props extends InputProps {
  label?: React.ReactNode;
  errorName?: string;
}

const InputField: React.FC<Props> = ({
  name,
  label,
  type,
  errorName,
  ...props
}) => (
  <FieldContainer
    name={name}
    label={label}
    type={type}
    errorName={errorName || name}
  >
    {({ inputProps, error }) => (
      <Input
        name={name}
        hasError={!!error}
        type={type}
        {...inputProps}
        {...props}
      />
    )}
  </FieldContainer>
);

export default InputField;
